<template>

  <div>
    <el-main class="menu-tree">
      <div class="header">
        <el-button type="primary" size="mini" @click="handleClick(null)">添加</el-button>
        <el-input placeholder="请输入内容" v-model="word_key" size="mini" class="input-with-select" @blur="search1">
          <el-button slot="append" icon="el-icon-search"></el-button>
        </el-input>
      </div>
      <div class="body">
        <el-table
          :data="tableData"
          border
          size="mini"
          :max-height="__TABLE_HEIGHT__"
          :stripe="true"
          :height="__TABLE_HEIGHT__">
          <el-table-column
            prop="id"
            label="ID"
            width="100">
          </el-table-column>
          <el-table-column
            prop="icon"
            label="图标"
            width="60">
            <template slot-scope="scope">
              <v-icon v-if="scope.row.icon" class="ic" style="color: #999999;font-size: 20px;">{{ scope.row.icon }}</v-icon>
            </template>
          </el-table-column>
          <el-table-column
            prop="label"
            label="名称"
            width="150">
          </el-table-column>
          <el-table-column
            prop="pid"
            label="父级"
            width="300">
            <template slot-scope="scope">
              <span :title="scope.row.pid">{{echoName(scope.row.pid)}}</span>
              <el-button @click="edtiPidTree(scope.row)" type="text" size="small" icon="el-icon-edit-outline"></el-button>
            </template>
          </el-table-column>
          <el-table-column
            prop="path"
            label="路径"
            width="120">
          </el-table-column>
          <el-table-column
            prop="is_menu"
            label="是否菜单"
            width="90">
            <template slot-scope="scope">
              <span v-if="scope.row.is_menu">是</span>
              <span v-if="!scope.row.is_menu">否</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="appurl"
            label="权限"
            width="120">
          </el-table-column>
          <el-table-column
            prop="weight"
            label="权重"
            width="90">
          </el-table-column>
          <el-table-column
            label="操作"
            width="220">
            <template slot-scope="scope">
              <el-button @click="handleClick(scope.row)" type="text" size="small" icon="el-icon-edit-outline">编辑</el-button>
              <el-button @click="del(scope.row)" type="text" size="small" icon="el-icon-delete">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="footer">
        <el-pagination v-if="pageObj&&pageObj.count"
                       background
                       :current-page.sync="pageObj.page*1"
                       :page-size="pageObj.size*1"
                       layout="prev, pager, next"
                       :total="pageObj.count*1"
                       @current-change="currentChange"
        >
        </el-pagination>
      </div>
    </el-main>

    <Modal
      v-model="show_status"
      :ok-text="'保存'"
      width="600"
      title="编辑"
      @on-ok="edit" @on-cancel="cancelModal">
      <Scroll height="600">
        <el-form class="fm" v-if="formData" ref="form" size="mini" :model="formData" label-width="80px">
          <el-form-item label="菜单编号">
            <el-input v-model="formData.id" disabled></el-input>
            <p class="fm-err">一经设置，不可修改</p>
          </el-form-item>
          <el-form-item label="菜单名称">
            <el-input v-model="formData.label"></el-input>
          </el-form-item>
          <el-form-item label="Icon">
            <div class="row">
              <el-button @click="showIcon">选择图标</el-button>
              <el-input v-model="formData.icon"></el-input>
            </div>
          </el-form-item>
          <el-form-item label="菜单路径">
            <el-input v-model="formData.path"></el-input>
          </el-form-item>
          <el-form-item label="菜单父级">

            <el-tree
              :data="tree"
              v-if="show_status"
              ref="tree"
              check-strictly
              highlight-current
              show-checkbox
              @check-change="treeHandleClick"
              node-key="id"
              :default-checked-keys="[formData.pid]"
              :default-expanded-keys="[formData.pid]"
              :props="defaultProps">
            </el-tree>
          </el-form-item>
          <el-form-item label="是否菜单">
            <el-switch v-model="formData.is_menu"></el-switch>
          </el-form-item>

          <el-form-item label="权重">
            <el-input v-model="formData.weight"></el-input>
          </el-form-item>

        </el-form>
      </Scroll>

    </Modal>

    <Modal
      v-model="show_status2"
      :ok-text="'保存'"
      width="400"
      title="编辑"
      @on-ok="edit2" @on-cancel="cancelModal2">
      <Scroll height="400">
        <el-tree
          :data="tree"
          v-if="show_status2"
          ref="tree2"
          check-strictly
          highlight-current
          show-checkbox
          @check-change="treeHandleClick2"
          node-key="id"
          :default-checked-keys="[formData2.pid]"
          :default-expanded-keys="[formData2.pid]"
          :props="defaultProps">
        </el-tree>
      </Scroll>
    </Modal>

    <Modal
      v-model="show_status3"
      :closable="false"
      width="800">
      <el-input placeholder="输入icon名称" v-model="icon_key" size="mini" class="input-with-select" @input="searchIcon">
        <el-button slot="append" icon="el-icon-search"></el-button>
      </el-input>
      <Scroll height="600">
        <div class="icon-list">
          <v-icon v-for="(item2,index2) in mdiIcons" :key="index2" class="ic" style="color: #999999;font-size: 20px;" @click="selectIcon(item2)">{{ item2.name }}</v-icon>
        </div>
      </Scroll>
    </Modal>


  </div>



</template>

<script>
// import tree from "../../../assets/js/tree";

import mdiIcon from "../../../assets/js/mdiIcon";

var getMenuList=function () {
  let menu_list=[];
  function getList(list=[]) {
    list.map(ret=>{
      let obj_item={};
      obj_item.id=ret.id;
      obj_item.label=ret.label;
      obj_item.icon=ret.icon;
      obj_item.path=ret.path||'';
      obj_item.pid=ret.pid;
      obj_item.is_menu=ret.is_menu?1:0;
      menu_list.push(obj_item)
      ret.children&&ret.children.length&&getList(ret.children);
    })
  }
  getList(JSON.parse(JSON.stringify(__MENU_LIST__)))
  return menu_list;
}

var getMenuTreeList=function () {
  function getList(list=[]) {
    let ls=[]
    return list.map(ret=>{
      let obj_item={};
      obj_item.value=ret.id;
      obj_item.label=ret.label;
      ret.children&&ret.children.length&&(obj_item.children=getList(ret.children));
      return obj_item;
    })
  }
  return getList(JSON.parse(JSON.stringify(__MENU_LIST__)));
}

export default {
  name: 'MenuTree',
  data () {
    return {
      tableData:[],
      pageObj:{},
      word_key:"",
      show_status:false,
      formData:{
        id: '',
        label: '',
        icon: '',
        path: '',
        pid: '',
        is_menu: false,
        weight:0
      },
      formData2:{
        id: '',
        label: '',
        icon: '',
        path: '',
        pid: '',
        is_menu: false,
        weight:0
      },
      show_status2:false,
      tree:JSON.parse(JSON.stringify(__MENU_LIST__)),
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      menu_list:getMenuList(),
      menu_tree_list:getMenuTreeList(),
      mdiIcons:[],
      show_status3:false,
      mdi_page:1,
      icon_key:''
    }
  },
  //界面没出来前加载
  created() {
    var that=this;
    setTimeout(function () {
      that.tree = JSON.parse(JSON.stringify(__MENU_LIST__));//tree
      that.tree.unshift({
        id: 0,
        label: '/',
        icon: 'mdi-home-outline ',
        path: '/',
        pid: 0,
        is_menu: true,
        weight:0
      });
      that.menu_list=getMenuList()
      that.menu_tree_list=getMenuTreeList()
    },2000)
    this.tree.unshift({
      id: 0,
      label: '/',
      icon: 'mdi-home-outline ',
      path: '/',
      pid: 0,
      is_menu: true,
      weight:0
    });
    // console.log("12345");
  },
  // 加载数据
  mounted(){
    this.getTable(1)
  },
  computed:{
    __MENU_LIST__(){
      return ERP.getStore().__MENU_LIST__
    },
    __TABLE_HEIGHT__(){
      return ERP.getStore().__TABLE_HEIGHT__
    }
  },
  watch:{
    __MENU_LIST__:function (n) {
      window.__MENU_LIST__=n;
      this.tree = JSON.parse(JSON.stringify(n));//tree
      this.tree.unshift({
        id: 0,
        label: '/',
        icon: 'mdi-home-outline ',
        path: '/',
        pid: 0,
        is_menu: true,
        weight:0
      });
      this.menu_list=getMenuList()
      this.menu_tree_list=getMenuTreeList()
    }
  },
  //事件
  methods: {
    getTable(p){
      var that=this;
      let purl='';
      purl+='?p='+p;
      that.word_key&&(purl+='&name='+that.word_key)
      that.$myhttp.get('admin/menu/getLists'+purl,{
        'Content-Type': 'application/json'
      }).then(ret=>{
        that.tableData=ret.data.list;
        that.pageObj=ret.data.page_obj;
      })

    },
    currentChange(e){
      this.getTable(e)
    },
    handleClick(item){
      this.show_status=true
      console.log(item)
      if(item){
        this.formData=item
      }else {
        this.formData= {
          id: (new Date()).getTime().toString().slice(0,11),
          label: '',
          icon: '',
          path: '',
          pid: '0',
          is_menu: false,
          weight:0
        }
      }

    },
    edit(){
      var that=this;
      that.show_status=false
      console.log(this.formData)
      !this.formData.pid&&(this.formData.pid="0");
      that.$myhttp.post("admin/menu/info",that.formData).then(ret=>{
        console.log(ret.data)
        that.getTable(that.pageObj.page)
        ERP.getMenuAllTree()
      })
    },
    edit2(){
      var that=this;
      that.show_status2=false
      that.$myhttp.post("admin/menu/info",that.formData2).then(ret=>{
        console.log(ret.data)
        that.getTable(that.pageObj.page)
        ERP.getMenuAllTree()
      })
    },
    del(item){
      var that=this;
      this.$confirm('您确定要删除【'+(item.label)+'】吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.$myhttp.post("admin/menu/del",{id:item.ids}).then(ret=>{
          that.$message({
            type: 'info',
            message: 'ret.data.msg'
          });
          that.getTable(that.pageObj.page)
          ERP.getMenuAllTree()
        })
      }).catch(() => {
        // that.$message({
        //   type: 'info',
        //   message: '已取消删除'
        // });
      });

    },
    treeHandleClick(data,checked, node){
      var that=this;
      if(typeof data.path ==="undefined"){
        that.$msgbox.alert("按钮类不许选择")
        that.$refs.tree.setCheckedNodes([]);
      }else {
        if(checked){
          that.$refs.tree.setCheckedNodes([data]);
          that.formData.pid=data.id
        }
      }
    },
    treeHandleClick2(data,checked, node){
      var that=this;
      if(typeof data.path ==="undefined"){
        that.$msgbox.alert("按钮类不许选择")
        that.$refs.tree2.setCheckedNodes([]);
      }else {
        if(checked){
          that.$refs.tree2.setCheckedNodes([data]);
          that.formData2.pid=data.id
        }
      }
    },
    cancelModal(e){
      this.formData={}
    },
    cancelModal2(){
      this.formData.pid=0;
    },
    search1(){
      this.getTable(1)
    },
    echoIds(id){
      var that=this;
      if(id!=0){
        let list=that.getTreeItem(id)
        return list.map(ret=>{ return ret.id });
      }else {
        return []
      }
    },
    echoName(id){
      var that=this;
      if(id!=0){
        let list=that.getTreeItem(id)
        return list.map(ret=>{ return ret.label }).join(" -> ");
      }else {
        return "--"
      }
    },
    getTreeItem(id){
      var that=this;
      if(id!=0){
        let obj_item=[];
        let obj_arr=[]
        obj_item[4]=that.menu_list.find(ret=>{return ret.id==id});
        obj_item[4]&&(obj_item[3]=that.menu_list.find(ret=>{return ret.id==obj_item[4].pid}))
        obj_item[3]&&(obj_item[2]=that.menu_list.find(ret=>{return ret.id==obj_item[3].pid}))
        obj_item[2]&&(obj_item[1]=that.menu_list.find(ret=>{return ret.id==obj_item[2].pid}))
        obj_item[1]&&(obj_item[0]=that.menu_list.find(ret=>{return ret.id==obj_item[1].pid}))
        obj_item.map(ret=>{
          ret&&(obj_arr.push(ret))
        })
        return obj_arr;
      }else {
        return []
      }
    },
    edtiPidTree(item){
      var that=this;
      let tree_menu=this.getTreeItem(item.pid)
      // console.log(tree_menu)
      this.show_status2=true;
      this.formData2=item
      // console.log(getMenuTreeList())
    },
    selectPid(e,i){
      console.log(e,i)
    },
    showIcon(){
      console.log("show_status3")
      var that=this;
      that.show_status3=true;
      that.mdiIcons=mdiIcon.icon_list().splice(0,600)
      setTimeout(function () {
        that.mdiIcons=mdiIcon.icon_list()
      },1000)
    },
    selectIcon(item){
      this.formData.icon=item.name
      this.show_status3=false;
    },
    searchIcon(){
      var that=this;
      that.mdiIcons=mdiIcon.icon_list().filter(ret=>{
        return ret.name.indexOf(that.icon_key)!==-1
      })
    }
  },

}
</script>
<style lang="scss" scoped>
.col{
  display: flex;
  flex-direction: column;
}
.row{
  display: flex;
  flex-direction: row;
  flex-wrap: unset;
  margin: unset;
}
.menu-tree{
  width: 100%;
  .header{
    display: flex;
    flex-direction: row;
    margin-bottom: 10px;
    .input-with-select{
      width: 200px;
      margin-left: 20px;
    }
  }
}
.fm{
  .fm-err{
    font-size: 12px;
    color: #F56C6C;
  }
}
.icon-list{
  display: -webkit-box;
 }
.ic{
  font-size: 20px;
  color: #afb0b4;
  padding: 5px;
  &:hover{
    background-color: #d0d0d0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Config/MenuTree.vue